import { $api } from '@/config/api';
import { setCookie, getCookie } from '@/utils/cookie';
import customFetch from '@/utils/fetch';

// 重试最大次数
const retryMaxCount = 3;
// 重试间隔
const retryInterval = 3000;
// 重试次数
let retryCount = 0;

declare global {
  interface Window {
    _TDID?: any;
  }
}

/**
 * 初始化TDID
 */
const initTDID = () => {
  window._TDID?.init(
    {
      channel: 400073,
      apiUrl: 'https://www.turingfraud.net'
    },
    function(res: any) {
      const isNewDeviceToken = localStorage?.getItem('is-new-device-token');
      if (res.ret === 0) {
        getDeviceToken().then((res: any) => {
          // 如果设备指纹不存在，或者设备指纹不是新的，则需要重新获取
          if (!getCookie('d') || !isNewDeviceToken) {
            getTdidDeviceId();
          }
        });
      }
    }
  );
};

/**
 * 获取设备指纹
 * @returns
 */
const getDeviceToken = (type?: 'update'): Promise<string> => {
  const localDeviceToken = localStorage.getItem('tdidDeviceToken');

  return new Promise(resolve => {
    if (type === 'update' || !localDeviceToken) {
      window._TDID?.getDeviceTokenV3(function(res: any) {
        if (res.ret === 0 && res?.deviceToken) {
          localStorage.setItem('tdidDeviceToken', res.deviceToken);
          resolve(res.deviceToken);
        }
      });
    } else {
      resolve(localDeviceToken);
    }
  });
};

/**
 * 获取腾讯设备指纹的设备ID
 */
const getTdidDeviceId = async(type?: 'update') => {
  let timer = null;
  const tdidDeviceToken = await getDeviceToken(type);

  const res: any = await $api.getTdidDeviceId({
    requestId: tdidDeviceToken,
    isSync: true
  });

  if (res.code === 200) {
    const deviceId = res.data?.deviceToken;
    deviceId && setCookie('d', res.data.deviceToken, 24 * 1000 * 60 * 60);
    localStorage?.setItem('is-new-device-token', '1');
    // 重置重试次数
    retryCount = 0;
    if (!deviceId) {
      timer && clearTimeout(timer);
      retryCount++;
      if (retryCount <= retryMaxCount) {
        timer = setTimeout(() => {
          getTdidDeviceId();
        }, res.data?.nextRequestWaitTime || retryInterval);
      }
    }
    return deviceId;
  }

};
/**
 * 上报设备指纹
 */
const reportDeviceToken = async() => {
  try {
    const tdidDeviceToken = await getDeviceToken('update');
    let deviceId = getCookie('d');

    // 如果deviceId不存在，则获取设备ID
    if (!deviceId) {
      deviceId = await getTdidDeviceId();
    }
    
    if (deviceId) {
      await customFetch({
        url: '@uapi/v1/device-token/report-v3',
        method: 'POST',
        body: JSON.stringify({
          requestId: tdidDeviceToken,
          deviceToken: deviceId
        }),
        // keepalive, 确保请求在页面卸载时仍然完成
        keepalive: true 
      });
    }
  } catch (error) {
    console.log(error);
  }
};

export { initTDID, getTdidDeviceId, reportDeviceToken };
